//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import sharedMethods from "../../../sharedMethods";
import DeleteMediaModal from "../DeleteMediaModal";
import { mapActions } from "vuex";
import _ from "lodash";

export default {
  props: ["content"],
  components: {},

  data() {
    return {
      currentContent: null,
      contentGroup: null,
      carouselModel: [],
      rotateDisabled: false,
      flipDisabled: false,
    };
  },

  created() {
    if (!this.content.contentGroup) {
      this.currentContent = this.content.clone();
    } else {
      this.currentContent = this.content.contentGroup[0].clone();
      this.contentGroup = this.content.contentGroup;
      this.carouselModel = this.contentGroup.map((elem) => {
        return elem.id;
      });
    }
  },

  methods: {
    ...mapActions(["rotateContent", "flipContent", "updateContentInfo", "checkIfContentIsInAPlaylist"]),

    // Following methods are required in order to make the modal functionality work. Dont change them.
    // Modal function
    show() {
      this.$refs.dialog.show();
    },
    // Modal function
    hide() {
      this.$refs.dialog.hide();
    },
    // Modal function
    onDialogHide() {
      this.$emit("hide");
    },
    // Modal function
    onOKClick() {
      this.$emit("ok");
      this.hide();
    },
    // Modal function
    onCancelClick() {
      this.hide();
    },

    async saveChanges() {
      // Dectect changes, if none
      if (
        this.contentGroup &&
        _.isEqual(
          this.currentContent,
          this.contentGroup.find((c) => {
            return c.id === this.currentContent.id;
          })
        )
      ) {
        return false;
      } else if (_.isEqual(this.currentContent, this.content)) {
        return false;
      }

      const loading = sharedMethods.loadingNotify("Saving changes...");
      try {
        await this.updateContentInfo({
          contentId: this.currentContent.id,
          name: this.currentContent.name,
          src: this.currentContent.src,
          duration: this.currentContent.duration,
          productUrl: this.currentContent.productUrl,
        });
        loading();
        sharedMethods.successNotify("Changes saved sucessfully.");
      } catch (err) {
        loading();
        sharedMethods.errorNotify("An error occured saving your changes. Please try again later or open a ticket.");
      }
    },
    onContentChange(newContent) {
      this.currentContent = this.contentGroup
        .find((c) => {
          return c.id === newContent;
        })
        .clone();
    },
    onDelete() {
      this.checkIfContentIsInAPlaylist(this.currentContent.id).then((response) => {
        console.log(response.data);
        this.$q.dialog({
          component: DeleteMediaModal,
          root: this,
          inUsePl: response.data,
          delContent: [this.content],
        });
      });
    },
    onFlip() {
      const loading = sharedMethods.loadingNotify("Flipping " + this.currentContent.name);
      this.flipDisabled = true;
      const flipInfo = {
        contentId: this.currentContent.id,
      };

      this.flipContent(flipInfo)
        .then(() => {
          // LOADING ANIMATION CANCEL
          loading();
          sharedMethods.successNotify("Flip complete. A horizontally inverted version is now in your library.");
        })
        .catch((err) => {
          this.rotateDisabled = false;
          // LOADING ANIMATION CANCEL
          loading();
          sharedMethods.errorNotify("Ooops. An error occured flipping your video. Please try again later or upload a flipped version from your computer.");
          console.log(err);
        });
    },
    onRotate() {
      const loading = sharedMethods.loadingNotify("Rotating please wait " + this.currentContent.name);
      this.rotateDisabled = true;
      let direction;

      if (this.currentContent.orientation === "LANDSCAPE") {
        direction = "PORTRAIT";
      } else {
        direction = "LANDSCAPE";
      }

      const rotateInfo = {
        contentId: this.currentContent.id,
        orientation: direction,
      };

      this.rotateContent(rotateInfo)
        .then(() => {
          caches.open("v1").then((cache) => {
            cache.delete(this.currentContent.src);
            cache.delete(this.currentContent.srcThumb);
            cache.delete(this.currentContent.srcPreview);
          });
          // LOADING ANIMATION CANCEL
          loading();
          sharedMethods.successNotify("Rotation complete. A rotated version is now in your library.");
        })
        .catch((err) => {
          this.rotateDisabled = false;
          // LOADING ANIMATION CANCEL
          loading();
          sharedMethods.errorNotify("Ooops. An error occured rotating your video. Please try again later or upload a rotated version from your computer.");
          console.log(err);
        });
    },
  },
};
